<template>
  <div class="bg-(--ui-bg) p-4">
    <div v-if="workflow?.quotation?.fuelCards?.length > 0 && (props.isPublicView || [Permission.Driver, Permission.HR, Permission.CustomerCare, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport, Permission.Dealer].some(p => userStore.hasPermission(p)))" class="mb-8">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-amber-100 dark:bg-amber-900/40">
          <UIcon name="i-mdi-gas-station" class="w-4.5 h-4.5 text-amber-600 dark:text-amber-400" />
        </div>
        <h5 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ t('additionalInfo.fuelCards.title') }}
        </h5>
        <span v-if="workflow?.quotation?.fuelCards?.length > 0" class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-xs font-bold bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300">{{ workflow.quotation?.fuelCards?.length }}</span>
      </div>
      <div v-if="workflow?.quotation?.fuelCards?.length > 0" class="rounded-xl border border-amber-200 dark:border-amber-800/60 overflow-x-auto shadow-sm">
        <table class="w-full">
          <thead>
            <tr class="bg-gradient-to-r from-amber-50 to-amber-100/60 dark:from-amber-900/30 dark:to-amber-800/20 border-b border-amber-200 dark:border-amber-800/60">
              <th class="text-left px-5 py-3 text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.fuelCards.cardType') }}</th>
              <th class="text-left px-5 py-3 text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.fuelCards.orderConfirmed') }}</th>
              <th class="text-left px-5 py-3 text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.fuelCards.validFrom') }}</th>
              <!--<th class="text-center px-5 py-3 text-xs font-semibold text-amber-700 dark:text-amber-300 uppercase tracking-wider whitespace-nowrap">Status</th>-->
            </tr>
          </thead>
          <tbody class="divide-y divide-amber-100 dark:divide-amber-900/30">
            <tr v-for="(card, index) in (workflow?.quotation?.fuelCards || [])" :key="index" class="hover:bg-amber-50/40 dark:hover:bg-amber-900/10 transition-colors duration-150">
              <td class="px-5 py-3.5 whitespace-nowrap">
                <span class="font-mono text-xs font-semibold px-2 py-1 bg-amber-50 dark:bg-amber-900/30 rounded-md text-amber-600 dark:text-amber-400 border border-amber-200/80 dark:border-amber-800/60">{{ card.type }}</span>
              </td>
              <td class="px-5 py-3.5 whitespace-nowrap">
                <span class="text-sm font-medium text-gray-900 dark:text-white">{{ formatDate(card.orderConfirmedDate, 'datetime', locale) }}</span>
              </td>
              <td class="px-5 py-3.5 whitespace-nowrap">
                <span class="text-sm font-medium text-gray-900 dark:text-white">{{ formatDate(card.validFrom, 'short', locale) }}</span>
              </td>
              <!--
              <td class="px-5 py-3.5 text-center whitespace-nowrap">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ring-1 ring-inset" :class="{
                  'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 ring-emerald-200/80 dark:ring-emerald-800/60': card.status === 'Active',
                  'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 ring-blue-200/80 dark:ring-blue-800/60': card.status === 'Delivered',
                  'bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 ring-amber-200/80 dark:ring-amber-800/60': card.status === 'Pending',
                  'bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 ring-red-200/80 dark:ring-red-800/60': card.status === 'Cancelled',
                }">{{ card.status }}</span>
              </td>
              -->
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-center py-8 text-gray-500 dark:text-gray-400">
        <UIcon name="i-mdi-gas-station" class="w-12 h-12 mx-auto mb-3 opacity-40" />
        <p>{{ t('additionalInfo.fuelCards.noCardsAvailable') }}</p>
      </div>
    </div>

    <div v-if="vehicleSection" class="mb-8">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-indigo-100 dark:bg-indigo-900/40">
          <UIcon name="i-mdi-car-hatchback" class="w-4.5 h-4.5 text-indigo-600 dark:text-indigo-400" />
        </div>
        <h5 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ t('additionalInfo.vehicle.title') }}
        </h5>
      </div>
      <div class="rounded-xl border border-indigo-200 dark:border-indigo-800/60 overflow-x-auto shadow-sm">
        <table class="w-full">
          <thead>
            <tr class="bg-gradient-to-r from-indigo-50 to-indigo-100/60 dark:from-indigo-900/30 dark:to-indigo-800/20 border-b border-indigo-200 dark:border-indigo-800/60">
              <th class="text-left px-5 py-3 text-xs font-semibold text-indigo-700 dark:text-indigo-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.code') }}</th>
              <th class="text-left px-5 py-3 text-xs font-semibold text-indigo-700 dark:text-indigo-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.vehicle.description') }}</th>
              <th class="text-right px-5 py-3 text-xs font-semibold text-indigo-700 dark:text-indigo-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.price') }}</th>
              <th class="text-center px-5 py-3 text-xs font-semibold text-indigo-700 dark:text-indigo-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.discount') }}</th>
              <th class="text-right px-5 py-3 text-xs font-semibold text-indigo-700 dark:text-indigo-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.afterDiscount') }}</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-indigo-100 dark:divide-indigo-900/30">
            <tr class="hover:bg-indigo-50/40 dark:hover:bg-indigo-900/10 transition-colors duration-150">
              <td class="px-5 py-3.5">
                <span v-if="vehicleSection.materialNumber" class="font-mono text-xs font-semibold px-2 py-1 bg-indigo-50 dark:bg-indigo-900/30 rounded-md text-indigo-600 dark:text-indigo-400 border border-indigo-200/80 dark:border-indigo-800/60">{{ vehicleSection.materialNumber }}</span>
              </td>
              <td class="px-5 py-3.5 whitespace-nowrap">
                <span class="text-sm font-medium text-gray-900 dark:text-white">{{ vehicleSection.description }}</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm font-medium tabular-nums text-gray-900 dark:text-white">{{ formatPriceWithCurrency(vehicleSection.listPrice, vehicleSection.currency, locale, 2) }}</span>
              </td>
              <td class="px-5 py-3.5 text-center">
                <span v-if="vehicleSection.discountRate && vehicleSection.discountRate > 0" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 ring-1 ring-inset ring-red-200/80 dark:ring-red-800/60">-{{ vehicleSection.discountRate }}%</span>
                <span v-else class="text-gray-300 dark:text-gray-600">&mdash;</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm font-semibold tabular-nums text-indigo-600 dark:text-indigo-400">{{ formatPriceWithCurrency(vehicleSection.afterDiscount, vehicleSection.currency, locale, 2) }}</span>
              </td>
            </tr>
            <tr v-if="vehicleSection.deliveryCost != null" class="hover:bg-indigo-50/40 dark:hover:bg-indigo-900/10 transition-colors duration-150 bg-indigo-50/20 dark:bg-indigo-900/5">
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3 whitespace-nowrap">
                <span class="text-sm text-gray-600 dark:text-gray-400">{{ t('additionalInfo.vehicle.deliveryCost') }}</span>
              </td>
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3 text-right whitespace-nowrap">
                <span class="text-sm tabular-nums text-gray-700 dark:text-gray-300">{{ formatPriceWithCurrency(vehicleSection.deliveryCost, vehicleSection.currency, locale, 2) }}</span>
              </td>
            </tr>
            <tr v-if="vehicleSection.registrationTax != null" class="hover:bg-indigo-50/40 dark:hover:bg-indigo-900/10 transition-colors duration-150 bg-indigo-50/20 dark:bg-indigo-900/5">
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3 whitespace-nowrap">
                <span class="text-sm text-gray-600 dark:text-gray-400">{{ t('additionalInfo.vehicle.registrationTax') }}</span>
              </td>
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3 text-right whitespace-nowrap">
                <span class="text-sm tabular-nums text-gray-700 dark:text-gray-300">{{ formatPriceWithCurrency(vehicleSection.registrationTax, vehicleSection.currency, locale, 2) }}</span>
              </td>
            </tr>
            <tr v-if="vehicleSection.registrationCost != null" class="hover:bg-indigo-50/40 dark:hover:bg-indigo-900/10 transition-colors duration-150 bg-indigo-50/20 dark:bg-indigo-900/5">
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3 whitespace-nowrap">
                <span class="text-sm text-gray-600 dark:text-gray-400">{{ t('additionalInfo.vehicle.registrationCost') }}</span>
              </td>
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3 text-right whitespace-nowrap">
                <span class="text-sm tabular-nums text-gray-700 dark:text-gray-300">{{ formatPriceWithCurrency(vehicleSection.registrationCost, vehicleSection.currency, locale, 2) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <div v-if="tyreItems.length > 0" class="mb-8">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-purple-100 dark:bg-purple-900/40">
          <UIcon name="i-mdi-tire" class="w-4.5 h-4.5 text-purple-600 dark:text-purple-400" />
        </div>
        <h5 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ t('additionalInfo.tyres.title') }}
        </h5>
        <span class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-xs font-bold bg-purple-100 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300">{{ tyreItems.length }}</span>
      </div>
      <div class="rounded-xl border border-purple-200 dark:border-purple-800/60 overflow-x-auto shadow-sm">
        <table class="w-full">
          <thead>
            <tr class="bg-gradient-to-r from-purple-50 to-purple-100/60 dark:from-purple-900/30 dark:to-purple-800/20 border-b border-purple-200 dark:border-purple-800/60">
              <th class="text-left px-5 py-3 text-xs font-semibold text-purple-700 dark:text-purple-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.code') }}</th>
              <th class="text-left px-5 py-3 text-xs font-semibold text-purple-700 dark:text-purple-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.description') }}</th>
              <th class="text-right px-5 py-3 text-xs font-semibold text-purple-700 dark:text-purple-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.price') }}</th>
              <th class="text-center px-5 py-3 text-xs font-semibold text-purple-700 dark:text-purple-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.discount') }}</th>
              <th class="text-right px-5 py-3 text-xs font-semibold text-purple-700 dark:text-purple-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.afterDiscount') }}</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-purple-100 dark:divide-purple-900/30">
            <tr v-for="(tyre, index) in tyreItems" :key="index" class="hover:bg-purple-50/40 dark:hover:bg-purple-900/10 transition-colors duration-150">
              <td class="px-5 py-3.5">
                <span class="font-mono text-xs font-semibold px-2 py-1 bg-purple-50 dark:bg-purple-900/30 rounded-md text-purple-600 dark:text-purple-400 border border-purple-200/80 dark:border-purple-800/60">{{ tyre.materialNumber || tyre.code }}</span>
              </td>
              <td class="px-5 py-3.5 whitespace-nowrap">
                <span class="text-sm font-medium text-gray-900 dark:text-white">{{ getAddonText(tyre) }}</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm font-medium tabular-nums text-gray-900 dark:text-white">{{ formatPriceWithCurrency(tyre.price, tyre.currency, locale, 2) }}</span>
              </td>
              <td class="px-5 py-3.5 text-center">
                <span v-if="tyre.discountPercentage && tyre.discountPercentage > 0" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 ring-1 ring-inset ring-red-200/80 dark:ring-red-800/60">-{{ (tyre.discountPercentage * 100) }}%</span>
                <span v-else class="text-gray-300 dark:text-gray-600">&mdash;</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm font-semibold tabular-nums text-purple-600 dark:text-purple-400">{{ formatPriceWithCurrency(tyre.priceAfterDiscount ?? tyre.price, tyre.currency, locale, 2) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="optionItems.length > 0" class="mb-8">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-cyan-100 dark:bg-cyan-900/40">
          <UIcon name="i-mdi-cog-outline" class="w-4.5 h-4.5 text-cyan-600 dark:text-cyan-400" />
        </div>
        <h5 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ t('additionalInfo.options.title') }}
        </h5>
        <span class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-xs font-bold bg-cyan-100 dark:bg-cyan-900/40 text-cyan-700 dark:text-cyan-300">{{ optionItems.length }}</span>
      </div>
      <div class="rounded-xl border border-cyan-200 dark:border-cyan-800/60 overflow-x-auto shadow-sm">
        <table class="w-full">
          <thead>
            <tr class="bg-gradient-to-r from-cyan-50 to-cyan-100/60 dark:from-cyan-900/30 dark:to-cyan-800/20 border-b border-cyan-200 dark:border-cyan-800/60">
              <th class="text-left px-5 py-3 text-xs font-semibold text-cyan-700 dark:text-cyan-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.code') }}</th>
              <th class="text-left px-5 py-3 text-xs font-semibold text-cyan-700 dark:text-cyan-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.options.description') }}</th>
              <th class="text-right px-5 py-3 text-xs font-semibold text-cyan-700 dark:text-cyan-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.price') }}</th>
              <th class="text-center px-5 py-3 text-xs font-semibold text-cyan-700 dark:text-cyan-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.discount') }}</th>
              <th class="text-right px-5 py-3 text-xs font-semibold text-cyan-700 dark:text-cyan-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.afterDiscount') }}</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-cyan-100 dark:divide-cyan-900/30">
            <tr v-for="item in optionItems" :key="item.code" class="hover:bg-cyan-50/40 dark:hover:bg-cyan-900/10 transition-colors duration-150">
              <td class="px-5 py-3.5">
                <span class="font-mono text-xs font-semibold px-2 py-1 bg-cyan-50 dark:bg-cyan-900/30 rounded-md text-cyan-600 dark:text-cyan-400 border border-cyan-200/80 dark:border-cyan-800/60">{{ item.code }}</span>
              </td>
              <td class="px-5 py-3.5 whitespace-nowrap">
                <span class="text-sm font-medium text-gray-900 dark:text-white">{{ getAddonText(item) }}</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm font-medium tabular-nums text-gray-900 dark:text-white">{{ formatPriceWithCurrency(item.price, item.currency, locale, 2) }}</span>
              </td>
              <td class="px-5 py-3.5 text-center">
                <span class="text-gray-300 dark:text-gray-600">&mdash;</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm tabular-nums text-gray-900 dark:text-white">{{ formatPriceWithCurrency(item.price, item.currency, locale, 2) }}</span>
              </td>
            </tr>
            <tr v-if="optionsTotals" class="bg-cyan-50/40 dark:bg-cyan-900/15 border-t-2 border-cyan-300 dark:border-cyan-700 font-semibold">
              <td class="px-5 py-3.5"></td>
              <td class="px-5 py-3.5 whitespace-nowrap">
                <span class="text-sm font-semibold text-gray-900 dark:text-white">{{ t('additionalInfo.options.total') }}</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm font-semibold tabular-nums text-gray-900 dark:text-white">{{ formatPriceWithCurrency(optionsTotals.listPriceSum, optionsTotals.currency, locale, 2) }}</span>
              </td>
              <td class="px-5 py-3.5 text-center">
                <span v-if="optionsTotals.discountRate && optionsTotals.discountRate > 0" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 ring-1 ring-inset ring-red-200/80 dark:ring-red-800/60">-{{ optionsTotals.discountRate }}%</span>
                <span v-else class="text-gray-300 dark:text-gray-600">&mdash;</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm font-semibold tabular-nums text-cyan-600 dark:text-cyan-400">{{ formatPriceWithCurrency(optionsTotals.afterDiscount, optionsTotals.currency, locale, 2) }}</span>
              </td>
            </tr>
            <tr v-if="optionsTotals?.registrationTax != null" class="bg-cyan-50/20 dark:bg-cyan-900/5 hover:bg-cyan-50/40 dark:hover:bg-cyan-900/10 transition-colors duration-150">
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3 whitespace-nowrap">
                <span class="text-sm text-gray-600 dark:text-gray-400">{{ t('additionalInfo.options.registrationTax') }}</span>
              </td>
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3"></td>
              <td class="px-5 py-3 text-right whitespace-nowrap">
                <span class="text-sm tabular-nums text-gray-700 dark:text-gray-300">{{ formatPriceWithCurrency(optionsTotals.registrationTax, optionsTotals.currency, locale, 2) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mb-8">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-emerald-100 dark:bg-emerald-900/40">
          <UIcon name="i-lucide-puzzle" class="w-4.5 h-4.5 text-emerald-600 dark:text-emerald-400" />
        </div>
        <h5 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ isPurchaseOrderView ? t('additionalInfo.accessories.titleAccessoriesOnly') : t('additionalInfo.accessories.title') }}
        </h5>
        <span v-if="accessoryItems.length > 0" class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-xs font-bold bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300">{{ accessoryItems.length }}</span>
      </div>
      <div v-if="accessoryItems.length > 0" class="rounded-xl border border-emerald-200 dark:border-emerald-800/60 overflow-x-auto shadow-sm">
        <table class="w-full">
          <thead>
            <tr class="bg-gradient-to-r from-emerald-50 to-emerald-100/60 dark:from-emerald-900/30 dark:to-emerald-800/20 border-b border-emerald-200 dark:border-emerald-800/60">
              <th class="text-left px-5 py-3 text-xs font-semibold text-emerald-700 dark:text-emerald-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.code') }}</th>
              <th class="text-left px-5 py-3 text-xs font-semibold text-emerald-700 dark:text-emerald-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.description') }}</th>
              <th class="text-right px-5 py-3 text-xs font-semibold text-emerald-700 dark:text-emerald-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.price') }}</th>
              <th class="text-center px-5 py-3 text-xs font-semibold text-emerald-700 dark:text-emerald-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.discount') }}</th>
              <th class="text-right px-5 py-3 text-xs font-semibold text-emerald-700 dark:text-emerald-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.afterDiscount') }}</th>
              <th v-if="props.workflow?.tenant === Tenant.CZ" class="text-left px-5 py-3 text-xs font-semibold text-emerald-700 dark:text-emerald-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.accessories.owner') }}</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-emerald-100 dark:divide-emerald-900/30">
            <tr v-for="item in accessoryItems" :key="item.code" class="hover:bg-emerald-50/40 dark:hover:bg-emerald-900/10 transition-colors duration-150">
              <td class="px-5 py-3.5">
                <span class="font-mono text-xs font-semibold px-2 py-1 bg-emerald-50 dark:bg-emerald-900/30 rounded-md text-emerald-600 dark:text-emerald-400 border border-emerald-200/80 dark:border-emerald-800/60">{{ item.materialNumber || item.code }}</span>
              </td>
              <td class="px-5 py-3.5 whitespace-nowrap">
                <span class="text-sm font-medium text-gray-900 dark:text-white">{{ getAddonText(item) }}</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm font-medium tabular-nums text-gray-900 dark:text-white">{{ formatPriceWithCurrency(item.price, item.currency, locale, 2) }}</span>
              </td>
              <td class="px-5 py-3.5 text-center">
                <span v-if="item.discountPercentage && item.discountPercentage > 0" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 ring-1 ring-inset ring-red-200/80 dark:ring-red-800/60">-{{ (item.discountPercentage * 100) }}%</span>
                <span v-else class="text-gray-300 dark:text-gray-600">&mdash;</span>
              </td>
              <td class="px-5 py-3.5 text-right whitespace-nowrap">
                <span class="text-sm font-semibold tabular-nums text-emerald-600 dark:text-emerald-400">{{ formatPriceWithCurrency(item.priceAfterDiscount ?? item.price, item.currency, locale, 2) }}</span>
              </td>
              <td v-if="props.workflow?.tenant === Tenant.CZ" class="px-5 py-3.5 whitespace-nowrap">
                <span v-if="item.owner" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ring-1 ring-inset" :class="item.owner === 'Drivalia' ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 ring-primary-200 dark:ring-primary-800' : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 ring-gray-200 dark:ring-gray-700'">{{ item.owner }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-center py-8 text-gray-500 dark:text-gray-400">
        <UIcon name="i-lucide-puzzle" class="w-12 h-12 mx-auto mb-3 opacity-40" />
        <p>{{ t('additionalInfo.accessories.noAccessoriesAvailable') }}</p>
      </div>
    </div>

    <div v-if="props.isPublicView || [Permission.Driver, Permission.HR, Permission.CustomerCare, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))" class="mb-8">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/40">
          <UIcon name="i-heroicons-wrench-screwdriver" class="w-4.5 h-4.5 text-blue-600 dark:text-blue-400" />
        </div>
        <h5 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ t('additionalInfo.services.title') }}
        </h5>
        <span v-if="serviceItems.length > 0" class="inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-xs font-bold bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300">{{ serviceItems.length }}</span>
      </div>
      <div v-if="serviceItems.length > 0" class="rounded-xl border border-blue-200 dark:border-blue-800/60 overflow-x-auto shadow-sm">
        <table class="w-full">
          <thead>
            <tr class="bg-gradient-to-r from-blue-50 to-blue-100/60 dark:from-blue-900/30 dark:to-blue-800/20 border-b border-blue-200 dark:border-blue-800/60">
              <th class="text-left px-5 py-3 text-xs font-semibold text-blue-700 dark:text-blue-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.services.serviceCode') }}</th>
              <th class="text-left px-5 py-3 text-xs font-semibold text-blue-700 dark:text-blue-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.services.serviceName') }}</th>
              <th v-if="props.isPublicView || [Permission.HR, Permission.CustomerCare, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))" class="text-right px-5 py-3 text-xs font-semibold text-blue-700 dark:text-blue-300 uppercase tracking-wider whitespace-nowrap">{{ t('additionalInfo.services.monthlyRate') }}</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-blue-100 dark:divide-blue-900/30">
            <tr v-for="item in serviceItems" :key="item.code" class="hover:bg-blue-50/40 dark:hover:bg-blue-900/10 transition-colors duration-150">
              <td class="px-5 py-3.5">
                <span class="font-mono text-xs font-semibold px-2 py-1 bg-blue-50 dark:bg-blue-900/30 rounded-md text-blue-600 dark:text-blue-400 border border-blue-200/80 dark:border-blue-800/60">{{ item.code }}</span>
              </td>
              <td class="px-5 py-3.5 whitespace-nowrap">
                <span class="text-sm font-medium text-gray-900 dark:text-white">{{ getAddonText(item) }}</span>
              </td>
              <td v-if="props.isPublicView || [Permission.HR, Permission.CustomerCare, Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.PurchaseSupport].some(p => userStore.hasPermission(p))" class="px-5 py-3.5 text-right whitespace-nowrap">
                <template v-if="item.included">
                  <span class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 ring-1 ring-inset ring-blue-200/80 dark:ring-blue-800/60">
                    <UIcon name="i-heroicons-check-circle" class="w-3.5 h-3.5" />
                    {{ t('additionalInfo.services.included') }}
                  </span>
                </template>
                <template v-else>
                  <div class="flex items-baseline justify-end gap-1">
                    <span v-if="item.kmRate != null" class="text-sm font-medium tabular-nums text-blue-600 dark:text-blue-400">{{ item.kmRate }} km</span>
                    <span v-if="item.kmRate != null && item.monthlyRate != null" class="text-gray-300 dark:text-gray-600 mx-0.5">/</span>
                    <span v-if="item.monthlyRate != null" class="text-sm font-semibold tabular-nums text-blue-600 dark:text-blue-400">{{ formatPriceWithCurrency(item.monthlyRate, getCurrencyCode(item.currency), locale, 2) }}</span>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-center py-8 text-gray-500 dark:text-gray-400">
        <UIcon name="i-heroicons-wrench-screwdriver" class="w-12 h-12 mx-auto mb-3 opacity-40" />
        <p>{{ t('additionalInfo.services.noServicesAvailable') }}</p>
      </div>
    </div>

    <div v-if="props.workflow?.tenant === Tenant.CZ && (props.isPublicView || [Permission.FleetManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.DeliverySpecialist, Permission.DeliveryManager].some(p => userStore.hasPermission(p)))" class="mb-8">
      <div class="flex items-center gap-3 mb-4">
        <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-orange-100 dark:bg-orange-900/40">
          <UIcon name="i-mdi-speedometer-medium" class="w-4.5 h-4.5 text-orange-600 dark:text-orange-400" />
        </div>
        <h5 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ t('additionalInfo.mileageRates.title') }}
        </h5>
      </div>
      <div v-if="workflow.quotation?.financials?.mvaLess || workflow.quotation?.financials?.mvaMore" class="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div v-if="workflow.quotation?.financials?.mvaLess" class="rounded-xl border border-orange-200 dark:border-orange-800/60 overflow-hidden shadow-sm">
          <div class="bg-gradient-to-r from-orange-50 to-orange-100/60 dark:from-orange-900/30 dark:to-orange-800/20 border-b border-orange-200 dark:border-orange-800/60 px-5 py-3 flex items-center justify-between">
            <div class="flex items-center gap-2">
              <UIcon name="i-mdi-speedometer-slow" class="w-4 h-4 text-orange-600 dark:text-orange-400" />
              <span class="text-xs font-semibold text-orange-700 dark:text-orange-300 uppercase tracking-wider">{{ t('additionalInfo.mileageRates.mvaLess') }}</span>
            </div>
            <span class="text-sm font-semibold tabular-nums text-orange-600 dark:text-orange-400">
              {{ t('additionalInfo.mileageRates.baseRate') }} {{ workflow.quotation.financials.mvaLess.rate ? formatPriceWithCurrency(workflow.quotation.financials.mvaLess.rate, workflow.quotation.financials.transactionCurrency, locale, 2) : '-' }}/km
            </span>
          </div>
          <div class="divide-y divide-orange-100 dark:divide-orange-900/30">
            <div v-for="rate in parseMileageRateStructure(workflow.quotation.financials.mvaLess.listedRates)" :key="rate.range" class="flex justify-between items-center px-5 py-3 hover:bg-orange-50/40 dark:hover:bg-orange-900/10 transition-colors duration-150">
              <span class="text-sm font-medium text-gray-900 dark:text-white">{{ rate.range }}</span>
              <span class="text-sm font-semibold tabular-nums text-orange-600 dark:text-orange-400">{{ rate.rate }}</span>
            </div>
          </div>
        </div>
        <div v-if="workflow.quotation?.financials?.mvaMore" class="rounded-xl border border-orange-200 dark:border-orange-800/60 overflow-hidden shadow-sm">
          <div class="bg-gradient-to-r from-orange-50 to-orange-100/60 dark:from-orange-900/30 dark:to-orange-800/20 border-b border-orange-200 dark:border-orange-800/60 px-5 py-3 flex items-center justify-between">
            <div class="flex items-center gap-2">
              <UIcon name="i-mdi-speedometer" class="w-4 h-4 text-orange-600 dark:text-orange-400" />
              <span class="text-xs font-semibold text-orange-700 dark:text-orange-300 uppercase tracking-wider">{{ t('additionalInfo.mileageRates.mvaMore') }}</span>
            </div>
            <span class="text-sm font-semibold tabular-nums text-orange-600 dark:text-orange-400">
              {{ t('additionalInfo.mileageRates.baseRate') }} {{ workflow.quotation.financials.mvaMore.rate ? formatPriceWithCurrency(workflow.quotation.financials.mvaMore.rate, workflow.quotation.financials.transactionCurrency, locale, 2) : '-' }}/km
            </span>
          </div>
          <div class="divide-y divide-orange-100 dark:divide-orange-900/30">
            <div v-for="rate in parseMileageRateStructure(workflow.quotation.financials.mvaMore.listedRates)" :key="rate.range" class="flex justify-between items-center px-5 py-3 hover:bg-orange-50/40 dark:hover:bg-orange-900/10 transition-colors duration-150">
              <span class="text-sm font-medium text-gray-900 dark:text-white">{{ rate.range }}</span>
              <span class="text-sm font-semibold tabular-nums text-orange-600 dark:text-orange-400">{{ rate.rate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center py-8 text-gray-500 dark:text-gray-400">
        <UIcon name="i-mdi-speedometer-medium" class="w-12 h-12 mx-auto mb-3 opacity-40" />
        <p>{{ t('additionalInfo.mileageRates.noMileageRatesAvailable') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from "vue-i18n";
import { formatDate } from "@/utils/date.ts";
import { Permission } from "@/types/enums/Permission.ts";
import { useUser } from "@/store";
import { formatPriceWithCurrency } from "@/utils/price.ts";
import { Tenant } from "@/types/enums/Tenant.ts";
import { sapLangMap } from "@/utils/sapLocalization";
import { isVehicleOrderType } from "@/types/enums/PurchaseOrder.ts";

const { t, locale } = useI18n()
const userStore = useUser();

interface Props {
  workflow?: any
  loading?: boolean
  isPublicView?: boolean
  purchaseOrderIndex?: number
  viewQuotationData?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  purchaseOrderIndex: 0,
  viewQuotationData: false
})

const currentPo = computed(() => props.workflow?.purchaseOrders?.[props.purchaseOrderIndex])
const isCustomerRole = computed(() => [Permission.Driver, Permission.HR, Permission.FleetManager].some(p => userStore.hasPermission(p)) && ![Permission.CustomerCare, Permission.PurchaseSupport, Permission.DeliverySpecialist, Permission.DeliveryManager, Permission.Backoffice, Permission.ClientAccount, Permission.KeyAccountManager, Permission.VehicleSupplier, Permission.TyreSupplier, Permission.SupplierSuperUser, Permission.Dealer].some(p => userStore.hasPermission(p)))
const isPurchaseOrderView = computed(() => !props.viewQuotationData && !props.isPublicView && !isCustomerRole.value && !!currentPo.value && isVehicleOrderType(currentPo.value.type))
const poCurrency = computed(() => currentPo.value?.financials?.transactionCurrency)

const getCurrencyCode = (currency: any): string => {
  if (typeof currency === 'string') return currency
  if (currency?.name) return currency.name

  return ''
}

const getAddons = (...categories: Array<'Service' | 'Accessory' | 'Option'>) => {
  if (!props.workflow?.quotation?.addons) return [];

  return props.workflow.quotation.addons.filter(addon => {
    const t = addon.$type || addon.type;

    return categories.some(c => t === `Nols${c}` || t === `Sap${c}`);
  });
}

const getPoAddons = (...types: string[]) => {
  const po = currentPo.value;
  if (!po?.addons) return [];
  const currency = poCurrency.value;
  
  return po.addons
    .filter((a: any) => {
      const t = a.$type || a.type;
      return types.some(type => t === type);
    })
    .map((a: any) => ({
      ...a,
      price: a.listPrice ?? a.price,
      currency: a.currency ?? currency,
      discountPercentage: a.discountRate != null ? a.discountRate / 100 : a.discountPercentage,
    }));
}

const vehicleSection = computed(() => {
  if (!isPurchaseOrderView.value) return null;
  
  const fin = currentPo.value?.financials;
  
  if (!fin) return null;
  
  const currency = poCurrency.value;
  const vehicle = props.workflow?.vehicle;
  
  return {
    description: vehicle ? `${vehicle.manufacturer} ${vehicle.model} ${vehicle.trim}`.trim() : '-',
    materialNumber: currentPo.value?.supplierMaterialNumber,
    listPrice: fin.listPrice,
    discountRate: fin.discountRate,
    discountAmount: fin.discountAmount,
    afterDiscount: fin.listPrice != null && fin.discountAmount != null ? fin.listPrice - fin.discountAmount : fin.listPrice,
    deliveryCost: fin.deliveryCost,
    registrationTax: fin.registrationTax,
    registrationCost: fin.registrationCost,
    currency,
  };
})

const accessoryItems = computed(() => {
  if (isPurchaseOrderView.value) {
    return getPoAddons('PurchaseOrderAccessoryDto');
  }
  
  return getAddons('Accessory', 'Option');
})

const optionItems = computed(() => {
  if (isPurchaseOrderView.value) {
    return getPoAddons('PurchaseOrderOptionDto');
  }
  
  return [];
})

const optionsTotals = computed(() => {
  if (!isPurchaseOrderView.value) return null;
  
  const fin = currentPo.value?.financials;
  
  if (!fin) return null;
  
  const currency = poCurrency.value;
  
  return {
    listPriceSum: fin.optionsListPriceSum,
    discountRate: fin.optionsDiscountRateSum,
    discountAmount: fin.optionsDiscountAmountSum,
    afterDiscount: fin.optionsListPriceSum != null && fin.optionsDiscountAmountSum != null ? fin.optionsListPriceSum - fin.optionsDiscountAmountSum : fin.optionsListPriceSum,
    registrationTax: fin.optionsRegistrationTaxSum,
    currency,
  };
})

const serviceItems = computed(() => getAddons('Service'))

function getAddonText(item: any) {
  const currentLocale = locale.value;
  const tenant = props.workflow?.tenant;
  const fallbackLangs = tenant === Tenant.FI ? ['fi', 'en'] : ['cs', 'en'];
  const langs = Array.from(new Set([currentLocale, ...fallbackLangs]));
  const allLangs = Array.from(new Set([...langs, ...langs.map(l => sapLangMap[l]).filter(Boolean)]));

  if (item.descriptions) {
    for (const lang of allLangs) {
      const desc = item.descriptions[lang];
      if (desc) {
        if (typeof desc === 'object' && desc.text) {
          return desc.specification ? `${desc.text} - ${desc.specification}` : desc.text;
        }

        if (typeof desc === 'string') {
          return desc;
        }
      }
    }
  }
  
  if (typeof item.description === 'string' && item.description) {
    return item.description;
  }

  if (item.texts) {
    for (const lang of allLangs) {
      const text = item.texts[lang];

      if (text) {
        return text;
      }
    }
  }

  return '';
}

const parseMileageRateStructure = (ratesString: string) => {
  if (!ratesString) return []

  return ratesString.split(';').map(rate => {
    const [range, amount] = rate.split(': ')

    return {
      range: range?.trim() ?? '',
      rate: amount?.trim() ?? ''
    }
  })
}

const tyreItems = computed(() => {
  if (isPurchaseOrderView.value) {
    return getPoAddons('PurchaseOrderTyreDto');
  }
  
  return [];
})
</script>